import type { NavItem } from "@bruntworkwear-apps/ui";
import { icons } from "@bruntworkwear-apps/ui";
import { createElement } from "react";

/**
 * Sentinel `href` marking the navigation entry that opens the report dialog
 * instead of navigating.
 *
 * The design system's `AppShell` takes `navItems` and a `renderLink` callback,
 * with no separate slot for an action — so the entry travels as a nav item and
 * `AppLayout` renders it as a `<button>` when it sees this href. A fragment,
 * not a path, so that if the branch is ever missed the worst case is a link that
 * goes nowhere rather than a route that does not exist.
 *
 * It is matched by identity in one place. Do not reuse it as a route.
 */
export const FEEDBACK_NAV_HREF = "#report-feedback";

/**
 * The navigation entry for reporting feedback.
 *
 * Appended after the four workflow steps, so it reads as "and if you have
 * something to say, here" rather than as a fifth thing to do. Deliberately
 * "feedback" rather than "a problem": two of the three things it accepts are an
 * idea and a question, and naming it after the third would quietly discourage
 * them.
 *
 * Still not a route. Clicking it opens a dialog over whatever the reporter is
 * looking at, which is what keeps the collected diagnostics about *their*
 * screen rather than about a feedback page.
 */
export const FEEDBACK_NAV_ITEM: NavItem = {
  label: "Report feedback",
  href: FEEDBACK_NAV_HREF,
  icon: createElement(icons.AlertTriangle, { size: 16, "aria-hidden": true }),
};
